import { LabelResourceRoleSubject } from '../types';

export default function isEqualLabelResourceRoleSubject(
  r1: LabelResourceRoleSubject,
  r2: LabelResourceRoleSubject
) {
  return r1.subjectType === r2.subjectType && r1.subjectId === r2.subjectId;
}
